(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["absoria-echantillons"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('absoria-sample-kit')) {
  customElements.define('absoria-sample-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const key = 'absoriaSampleKit';
      const selected = new Map();
      const available = new Map();
      const cards = Array.from(this.querySelectorAll('[data-card]'));
      const summary = this.querySelector('[data-summary]');
      const checkout = this.querySelector('[data-checkout]');
      const message = this.querySelector('[data-message]');
      const cartLink = this.querySelector('[data-cart-link]');
      const kitId = this.dataset.kitVariant;
      const root = (window.Shopify?.routes?.root || this.dataset.rootUrl || '/').replace(/\/?$/, '/');
      let busy = false;
      let alreadyInCart = false;
      const label = sample => sample.variantTitle && sample.variantTitle !== 'Default Title'
        ? `${sample.productTitle} — ${sample.variantTitle}` : sample.productTitle;
      const persist = () => {
        try { sessionStorage.setItem(key, JSON.stringify(Array.from(selected.entries()))); } catch (_) { /* Navigation privée : le kit reste utilisable. */ }
      };
      cards.forEach(card => {
        const control = card.querySelector('[data-variant]');
        if (!control) return;
        const variants = control.tagName === 'SELECT' ? Array.from(control.options) : [control];
        variants.forEach(variant => available.set(String(variant.value), {
          variantId: String(variant.value), productId: card.dataset.productId,
          productTitle: card.dataset.productTitle, variantTitle: variant.dataset.variantTitle || ''
        }));
      });
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
        if (Array.isArray(saved)) saved.forEach(entry => {
          if (!Array.isArray(entry)) return;
          const id = String(entry[0]);
          if (selected.size < 3 && available.has(id)) selected.set(id, available.get(id));
        });
      } catch (_) { /* Une sauvegarde invalide est ignorée. */ }
      cards.forEach(card => {
        const control = card.querySelector('[data-variant]');
        const saved = Array.from(selected.values()).filter(sample => sample.productId === card.dataset.productId);
        if (control && saved.length === 1) control.value = saved[0].variantId;
      });
      const render = () => {
        this.querySelector('[data-count]').textContent = `${selected.size} / 3`;
        this.querySelectorAll('.ask__progress span').forEach((slot, index) => slot.classList.toggle('is-filled', index < selected.size));
        checkout.disabled = busy || alreadyInCart || selected.size === 0 || !/^\d+$/.test(kitId);
        cards.forEach(card => {
          const control = card.querySelector('[data-variant]');
          const button = card.querySelector('[data-add]');
          const chosen = control && selected.has(control.value);
          button.disabled = busy || !control || (!chosen && selected.size >= 3);
          button.textContent = !control ? 'Indisponible' : chosen ? 'Retirer du kit' : 'Ajouter au kit';
          button.classList.toggle('is-selected', Boolean(chosen));
          card.classList.toggle('is-selected', Array.from(selected.values()).some(sample => sample.productId === card.dataset.productId));
          if (control) control.disabled = busy;
        });
        summary.replaceChildren();
        if (!selected.size) {
          const empty = document.createElement('p');
          empty.className = 'ask__empty';
          empty.textContent = 'Votre kit commence ici. Choisissez votre premier échantillon.';
          summary.append(empty);
        }
        selected.forEach((sample, id) => {
          const row = document.createElement('div');
          row.className = 'ask__item';
          const text = document.createElement('span');
          text.textContent = label(sample);
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'ask__remove'; remove.textContent = '×';
          remove.setAttribute('aria-label', `Retirer ${label(sample)} du kit`);
          remove.disabled = busy;
          remove.addEventListener('click', () => {
            selected.delete(id); persist(); render();
            const next = summary.querySelector('button') || this.querySelector('[data-add]:not(:disabled)');
            if (next) next.focus();
          });
          row.append(text, remove); summary.append(row);
        });
      };
      cards.forEach(card => {
        const control = card.querySelector('[data-variant]');
        card.querySelector('[data-add]').addEventListener('click', () => {
          if (busy || !control || !available.has(control.value)) return;
          const id = control.value;
          if (selected.has(id)) selected.delete(id);
          else if (selected.size < 3) selected.set(id, available.get(id));
          persist(); render();
        });
        if (control) control.addEventListener('change', render);
      });
      const params = new URLSearchParams(window.location.search);
      const requestedCard = cards.find(card => card.dataset.productHandle === params.get('produit'));
      if (requestedCard) {
        const control = requestedCard.querySelector('[data-variant]');
        const requestedId = params.get('variant');
        if (control) {
          const requested = requestedId && available.get(requestedId);
          if (requested && requested.productId === requestedCard.dataset.productId) control.value = requestedId;
          if (requestedId && (!requested || requested.productId !== requestedCard.dataset.productId)) {
            message.textContent = 'La taille demandée n’est pas disponible. Choisissez un autre format.';
          } else if (available.has(control.value) && selected.size < 3) {
            selected.set(control.value, available.get(control.value));
          } else if (!selected.has(control.value) && selected.size >= 3) {
            message.textContent = 'Votre kit contient déjà 3 échantillons. Retirez-en un pour modifier votre sélection.';
          }
        } else message.textContent = 'Ce produit est temporairement indisponible.';
      }
      checkout.addEventListener('click', async () => {
        if (busy || alreadyInCart || !selected.size || !/^\d+$/.test(kitId)) return;
        busy = true; message.textContent = ''; checkout.textContent = 'Vérification…'; render();
        const properties = {};
        Array.from(selected.values()).forEach((sample, index) => { properties[`Échantillon ${index + 1}`] = label(sample); });
        try {
          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!cartResponse.ok) throw new Error('Lecture du panier impossible');
          const cart = await cartResponse.json();
          if (cart.items.some(item => String(item.variant_id) === kitId)) {
            alreadyInCart = true;
            message.textContent = 'Votre kit d’échantillons est déjà dans le panier.';
            checkout.textContent = 'Kit déjà dans le panier'; cartLink.hidden = false;
            return;
          }
          checkout.textContent = 'Ajout en cours…';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: kitId, quantity: 1, properties }] })
          });
          if (!response.ok) throw new Error('Ajout au panier impossible');
          alreadyInCart = true;
          checkout.textContent = 'Kit ajouté au panier';
          try { sessionStorage.removeItem(key); } catch (_) { /* Le panier a déjà été mis à jour. */ }
          window.location.assign(this.dataset.cartUrl);
        } catch (_) {
          message.textContent = 'Impossible d’ajouter le kit au panier. Merci de réessayer.';
          checkout.textContent = 'Ajouter mon kit au panier';
        } finally { busy = false; render(); }
      });
      if (!/^\d+$/.test(kitId)) message.textContent = 'Le kit n’est pas disponible pour le moment.';
      persist(); render();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('absoria-footer-menu')) {
    customElements.define('absoria-footer-menu', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          if (!this.details || !this.summary) return;
          this.media = matchMedia('(min-width: 750px)');
          this.update = () => {
            this.details.open = this.media.matches;
            this.summary.setAttribute('aria-expanded', String(this.details.open));
          };
          this.sync = () => this.summary.setAttribute('aria-expanded', String(this.details.open));
          this.click = (event) => { if (this.media.matches) event.preventDefault(); };
          this.media.addEventListener('change', this.update);
          this.details.addEventListener('toggle', this.sync);
          this.summary.addEventListener('click', this.click);
          this.update();
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.media?.removeEventListener('change', this.update);
        this.details?.removeEventListener('toggle', this.sync);
        this.summary?.removeEventListener('click', this.click);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
